import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContentService } from 'src/app/views/content/content.service';
import { AuthService } from 'src/app/auth.service';
import { MySpaceService } from 'src/app/views/my-space/my-space.service';
import { MaterialModule } from '../../material.module';
import { AppConfirmService } from '../../services/app-confirm/app-confirm.service';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'app-course-permissions',
  templateUrl: './course-permissions.component.html',
  styleUrls: ['./course-permissions.component.scss'],
  standalone: true,
  imports: [FormsModule, TranslateModule, MaterialModule],
})
export class CoursePermissionsComponent implements OnInit {
  displayedCourses;
  loading = true;

  constructor(
    private contentService: ContentService,
    private toast: ToastService,
    private authService: AuthService,
    private confirmService: AppConfirmService,
    private mySpaceService: MySpaceService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    // NOTE: In case the search is now performed remotely
    this.displayedCourses = [];
  }
  searchTerm = '';
  _filter;
  ngOnInit() {
    this.getCourseRequest();
  }
  languageIsFr() {
    return this.translate.currentLang == 'fr';
  }

  searchCoursesByName() {
    if (this.searchTerm.length) {
      this.contentService.searchCoursesByName(this.searchTerm).subscribe((res) => {
        this.displayedCourses = res;
        this.loading = false;
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  getCourseRequest() {
    this.searchCoursesByName();
  }

  sendCourseRequest(courseID, approverID) {
    // this.confirmService.confirm({message:"Voulez-vous envoyer cette requête?"}).subscribe(res => {
    // if (res) {
    this.loading = true;
    if (this.requestIsOngoing(courseID)) {
      this.loading = false;
      this.toast.snackbar.open(this.translate.instant('Snackbar.RequestAlreadyPresent'), 'Ok', { duration: 2000 });
      return;
    }
    this.contentService.requestCourseAccess({ courseID, approverID }).subscribe(
      (res) => {
        this.getCourseRequest();
      },
      (err) => {
        this.loading = false;
        this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
          duration: 2000,
        });
      }
    );
    //    }
    //  })
  }

  cancelRequest(courseID) {
    const courseIndex = this.displayedCourses.findIndex((course) => course._id == courseID);
    if (!this.displayedCourses[courseIndex]) {
      return false;
    }
    const requestID = this.displayedCourses[courseIndex].requests.find((request) => request.requesterID == this.authService.userInfo()._id)._id;

    this.confirmService.confirm({ message: this.translate.instant('Confirm.CancelRequest') }).subscribe((res) => {
      if (res) {
        this.mySpaceService.cancelRequest({ requestID }).subscribe(
          (res) => {
            this.getCourseRequest();
          },
          (err) => {
            this.loading = false;
            this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', { duration: 2000 });
          }
        );
      }
    });
  }

  isAlreadyInCourse(courseID) {
    const courseIndex = this.displayedCourses.findIndex((course) => course._id == courseID);
    if (!this.displayedCourses[courseIndex]) {
      return false;
    }
    return this.displayedCourses[courseIndex].users.hasAcces;
  }

  requestIsOngoing(courseID) {
    const courseIndex = this.displayedCourses.findIndex((course) => course._id == courseID);
    if (!this.displayedCourses[courseIndex]) {
      return false;
    }
    return (
      this.displayedCourses[courseIndex].requests.findIndex((request) => {
        return request.requesterID == this.authService.userInfo()._id;
      }) != -1
    );
  }
}
